// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fBEP","content":"styles_content__2woVO","tableWrap":"styles_tableWrap__3xYwt"};